import styled from 'styled-components'
import css from '@styled-system/css'

export const Container = styled.img`
  display: inline-block;
  flex: none;
  border-radius: 50%;
  ${css({
    backgroundColor: 'gray.0',
  })}
`
